import React from 'react';
import cx from 'classnames';
import { uniq } from 'lodash';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import useResponsiveButtonSize from '../../utils/useResponsiveButtonSize';
import GridHidden from '../GridHidden';
import { getLabel, getPlainTextLabel } from './utils';

const useStyles = makeStyles(theme => ({
  filterGroup: {
    marginBottom: theme.spacing(4),
  },
}));

const sortOptionsAlphabetical = labels => (a, b) => {
  const labelA = getPlainTextLabel(a, labels).toLowerCase();
  const labelB = getPlainTextLabel(b, labels).toLowerCase();
  return labelA.localeCompare(labelB);
};

const GroupFilters = props => {
  const {
    data,
    filteredData,
    labels,
    groupBy,
    activeFilters,
    onClickFilter,
    onResetFilter,
  } = props;
  const buttonSize = useResponsiveButtonSize();
  const options = uniq(data.filter(groupBy).map(groupBy));
  if (options.length === 0) return null;
  const availableOptions = uniq(
    filteredData.filter(props.groupBy).map(props.groupBy),
  );
  const classes = useStyles();

  const handleClickAll = () => {
    onResetFilter();
  };

  const handleClickFilterButton = group => {
    onClickFilter(group);
  };

  return (
    <React.Fragment>
      {options.length > 0 && (
        <Grid container spacing={2} style={{marginBottom: 8}}>
          <GridHidden item xsDown sm={2} />
          <Grid item xs={12} sm={8} style={{display: 'flex', gap: 16, flexWrap: 'wrap'}}>
            <Button
              variant={activeFilters.length === 0 ? 'contained' : 'outlined'}
              onClick={handleClickAll}
              size={buttonSize}
            >
              Alle
            </Button>
            {options.sort(sortOptionsAlphabetical(labels)).map(g => (
              <Button
                key={g}
                disabled={!availableOptions.includes(g)}
                onClick={() => handleClickFilterButton(g)}
                variant={activeFilters.includes(g) ? 'contained' : 'outlined'}
                size={buttonSize}
              >
                {getLabel(g, labels)}
              </Button>
            ))}
          </Grid>
          <GridHidden item xsDown sm={2} />
        </Grid>
      )}
    </React.Fragment>
  );
};

GroupFilters.defaultProps = {
  activeFilters: [],
};

export default GroupFilters;
